import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/components/loginPage'
import managePage from '@/components/managePage'
import unitMgmt from "@/components/unitMgmt";
import emptyPage from "@/components/emptyPage";
import applicationMenuMgmt from "@/components/applicationMenuMgmt";
import serviceResourceMgmt from "@/components/serviceResourceMgmt";
import authoritySchemeMgmt from "@/components/authoritySchemeMgmt";
import serviceList from "@/components/serviceList";
import applyList from "@/components/applyList";
import serverMgmt from "@/components/serverMgmt";
import serviceMgmt from "@/components/serviceMgmt";
import serviceInstanceList from "@/components/serviceInstanceList";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/managePage',
      name: 'managePage',
      component: managePage,
      redirect: '/managePage/',
      children: [
        {
          path: '/loginPage',
          name: 'loginPage',
          component: loginPage
        },
        {
          path: 'emptyPage',
          name: 'emptyPage',
          component: emptyPage
        },
        {
          path: 'unitMgmt',
          name: 'unitMgmt',
          component: unitMgmt,
        },
        {
          path: 'applicationMenuMgmt',
          name: 'applicationMenuMgmt',
          component: applicationMenuMgmt,
        },
        {
          path: 'serviceResourceMgmt',
          name: 'serviceResourceMgmt',
          component: serviceResourceMgmt,
        },
        {
          path: 'authoritySchemeMgmt',
          name: 'authoritySchemeMgmt',
          component: authoritySchemeMgmt,
        },
        {
          path: 'serviceList',
          name: 'serviceList',
          component: serviceList,
        },
        {
          path: 'applyList',
          name: 'applyList',
          component: applyList,
        },
        {
          path: 'serverMgmt',
          name: 'serverMgmt',
          component: serverMgmt,
        },
        {
          path: 'serviceMgmt',
          name: 'serviceMgmt',
          component: serviceMgmt,
        },
        {
          path: 'serviceInstanceList',
          name: 'serviceInstanceList',
          component: serviceInstanceList,
        }
      ]
    },
    { path: '*', component: loginPage, name: "default" }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js